import api from "../Api";

// helper: build auth headers from stored token
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// جلب قائمة الدول للإدارة — يضيف api_password تلقائيًا ويمكن تمرير params إضافية
export const getAdminCountries = async (params = {}) => {
  try {
    const headers = {
      ...getAuthHeaders(),
    };
    const mergedParams = {
      api_password: "EcommercApp@2026_$",
      ...params,
    };
    const response = await api.get("/admin/get-countries", { params: mergedParams, headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin countries:", error);
    throw error;
  }
};

// إنشاء دولة (يدعم form-data مع حقل image) — يضيف api_password كـ params
export const createCountry = async (formData) => {
  try {
    // normalize status/default when formData provided
    if (typeof FormData !== "undefined" && formData instanceof FormData) {
      ["status", "default"].forEach((field) => {
        const v = formData.get(field);
        if (v !== null) {
          if (v === true || v === "true" || v === "1" || v === 1 || v === "active") {
            formData.set(field, "1");
          } else {
            formData.set(field, "0");
          }
        }
      });
    }

    const headers = {
      "Content-Type": "multipart/form-data",
      ...getAuthHeaders(),
    };
    const params = {
      api_password: "EcommercApp@2026_$",
    };
    const response = await api.post("/admin/create-country", formData, { headers, params });
    return response.data;
  } catch (error) {
    console.error("Error creating country:", error);
    // surface validation errors if present
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// تحديث دولة (يدعم form-data مع id أو country_id) — يرسل POST إلى /admin/update-country/{id}?api_password=...
export const updateCountry = async (formData) => {
  // احصل على الـ id من formData
  const id = (typeof FormData !== "undefined" && formData instanceof FormData)
    ? (formData.get("country_id") || formData.get("id") || formData.get("countryId"))
    : null;

  if (!id) throw new Error("country_id or id is required to update country.");

  // normalize status/default to '1'/'0'
  if (typeof FormData !== "undefined" && formData instanceof FormData) {
    ["status", "default"].forEach((field) => {
      const v = formData.get(field);
      if (v !== null) {
        if (v === true || v === "true" || v === "1" || v === 1 || v === "active") {
          formData.set(field, "1");
        } else {
          formData.set(field, "0");
        }
      }
    });
  }

  const headers = {
    "Content-Type": "multipart/form-data",
    ...getAuthHeaders(),
  };
  const params = { api_password: "EcommercApp@2026_$" };

  try {
    const response = await api.post(`/admin/update-country/${id}`, formData, { headers, params });
    return response.data;
  } catch (error) {
    console.error("Error updating country:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach(v => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};
